module.exports = __webpack_public_path__ + "static/media/zee.6cb9bc94.svg";